import React, { useState, useEffect } from "react";
import { message } from "antd";
import { v4 as uuidv4 } from "uuid";
import db from "../../../database";
import { SyncData } from "./Tables-Management/SyncData";
import { useEventBus } from "../../../lib/components/EventBusProvider";
import OrderCompleteScreen from "./components/OrderCompleteScreen";
import OrderDetailsSidebar from "./components/OrderDetailsSidebar";
import PaymentCheckout from "./components/PaymentCheckout";
import OrderHistoryList from "./components/OrderHistoryList";
import useAuthStore from "../../../stores/useAuthStore";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import useCartStore from "../../../stores/useCartStore";
import useRestaurantStore from "../../../stores/useRestaurantStore";

const OrderListComponent = ({
  setSelectedProductInCart,
  selectedProductId,
  setSelectedProductId,
  manualDiscountRestaurant,
  cart,
  selectedTable,
  setSelectedTable,
  tillDataPaymentMethods,
  setSelectedPaymentMethod,
  selectedPaymentMethod,
  setIsCardPaymentFlag,
  processOrder,
  amount,
  onChangeAmount,
  paymentModalInputRef,
  setIsInputFocused,
  requestPayment,
  handleCashPayment,
  handleAmount,
  setNumb,
  setKeyValue,
  paymentVisible,
  setPaymentVisible,
  showOrderCompleteFlag,
  setShowOrderCompleteFlag,
  userPreferences,
  showProducts,
  setShowProducts,
  filteredPaymentMethods,
  getFilteredPaymentMethods,
  tableCards,
  setAmount,
  setTableCards,
  setCart,
  denaminationsKeyboard,
  setDenaminationsKeyboard,
  saleType,
  setSaleType,
  occupiedDataTablesData,
  setOcupiedTablesData,
  reservedTablesData,
  setReservedTablesData,
  tableList,
  setTableList,
  showSplitBill,
  setShowSplitBill,
  splitBillScreen,
  setSplitBillScreen,
  numSplits,
  setNumSplits,
  setDisplayCustomerSearch,
  deleteProduct,
  handleOrder,
  showAllItems,
  setShowAllItems,
  splitCarts,
  setSplitCarts,
  isSplitBill,
  setIsSplitBill,
  currentSplitIndex,
  setCurrentSplitIndex,
  recordState,
  setRecardState,
  removeSplit,
  setRemoveSplit,
  setMainTableData,
  setSelectedSaleType,
  selectedSaleType,
  setSelectedSaleTypeData,
  searchOrderHistory,
  orderHistoryDetails,
  setOrderHistoryDetails,
  increaseProductQty,
  getSalesHistoryData,
  isPrintModeXML,
  upsertPOSLog,
  setFiltersFlag,
  dateRange,
  setDateRange,
  getDisplayDate,
  content,
  searchHistoryInput,
  setSearchhistoryInput,
  ordersCopy,
  isPopoverVisible,
  setPopoverVisible,
  dateRef,
  filtersFlag,
  setShowSendToKitchen,
  showSendToKitchen,
  sortedSaleTypes,
  setSelectedSaleTypeIndex,
  selectedReturnOrder,
  setSelectedReturnOrder,
  setCheckedKeys,
  checkedKeys,
  addSelectedReturnProductsToCart,
  getProductData,
  handleSaveReturnCartRecord,
  dataSource,
  setDataSource,
  productCategoriesList,
  setProductCategoriesList,
  selectedCategory,
  setSelectedCategory,
  restaurantProductCategory,
  bestsellerCategories,
  handleCategoryClick,
  saleTypeProducts,
  setSaleTypeProducts,
  handleSelectedSaleTypeForProducts,
  showReturnPurchase,
  setShowReturnPurchase,
  selectPurchaseBillForReturn,
  retrunSearchType,
  setReturnSearchType,
  searchReturnHistory,
  restaurantButtonLoading,
  setRestaurantButtonLoading,
  loading,
  setLoading,
}) => {
  const { dispatchEvent } = useEventBus();
  const [orderTypeData, setOrderTypeData] = useState(0);
  const tillData = useAuthStore((s) => s.tillData);
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const currenciesList = tillData?.tillAccess.csBunit.currencies;
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const ObFlag = tillData.tillAccess.cwrTill.printTemplate.obController === "Y" ? true : false;
  const CWHardwareController = tillData.tillAccess.cwrTill.printTemplate.cwController === "Y" ? true : false;

  const [OrderedItem, setOrderedItem] = useState([]);
  const [completedSOrderID, setCompletedSOrderID] = useState(null);
  const [charges, showCharges] = useState(false);
  const [orderColors, setOrderColors] = useState({});
  const [salesHistoryDrawer, setSalesHistoryDrawer] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [returnDrawerOpen, setReturnDrawerOpen] = useState(false);
  const [returnItem, setReturnItem] = useState(null);
  const [returnQty, setReturnQty] = useState(1);
  // selectedPayment is shared between PaymentCheckout and OrderDetailsSidebar
  const [selectedPayment, setSelectedPayment] = useState(false);

  const userData = useAuthStore.getState().userData;
  const tillValue = useAuthStore.getState().tillValue;
  const tableData = useRestaurantStore.getState().tableName;
  const guestName = tableData?.guestName || "";

  // ─── Helpers ───────────────────────────────────────────────────────────────

  const getAllSaleTypes = async () => {
    const saleData = await db.posSaletypes.toArray();
    return saleData;
  };

  const findMatchingColor = async (order) => {
    const saleTypes = await getAllSaleTypes();
    const saleTypeIdFromOrder = order?.saleType?.cwrSaletypeId;
    const matchingSaleType = saleTypes.find(
      (saleType) => saleType?.cwrSaletype?.cwrSaletypeId === saleTypeIdFromOrder
    );
    return matchingSaleType?.cwrSaletype?.colourCode || "green";
  };

  const getDefaultSaleType = async () => {
    const saleData = await db.posSaletypes.toArray();
    const defaultSale = saleData.find((sale) => sale?.cwrSaletype?.isdefault === "Y");
    if (defaultSale) return defaultSale;
    if (saleType === "DI") {
      const dineInSale = saleData.find((sale) => sale?.cwrSaletype?.fulfilmentType === "DI");
      if (dineInSale) return dineInSale;
    } else if (saleType === "TA") {
      const takeAwaySale = saleData.find((sale) => sale?.cwrSaletype?.fulfilmentType === "TA");
      if (takeAwaySale) return takeAwaySale;
    }
    return undefined;
  };

  const modulo = (a, b) => a - b * Math.floor(a / b);

  const markTableBillRequested = async () => {
    const tableInfo = useRestaurantStore.getState().tableName;
    if (!tableInfo?.cwrFbTableId) return;
    const tableRecord = await db.tableData.where("cwrFbTableId").equals(tableInfo.cwrFbTableId).first();
    if (!tableRecord) return;
    tableRecord.statusType = "BRQ";
    tableRecord.tableSync = "N";
    await db.tableData.put(tableRecord, tableRecord.cwrFbTableId);
    await SyncData(tableRecord, "upsertTableStatus");
    setTableCards((prev) =>
      prev.map((t) => (t.cwrFbTableId === tableRecord.cwrFbTableId ? { ...t, ...tableRecord } : t))
    );
    setTableList?.((prev) =>
      prev.map((t) => (t.cwrFbTableId === tableRecord.cwrFbTableId ? { ...t, ...tableRecord } : t))
    );
  };

  const handleDeletePayment = (payment) => {
    let paid = 0;
    Promise.all(
      cart.payments.map(async (pay) => {
        if (payment.paymentEntryId && pay.paymentEntryId) {
          // Permanent fix (BUG-1829): match by the unique paymentEntryId assigned at creation
          // (paymentController.js addAmount) instead of shared `name`. Falls back to the legacy
          // name/authorization/transactionId heuristics below only when the id is missing (entries
          // created before this fix).
          if (pay.paymentEntryId !== payment.paymentEntryId) {
            paid = paid + parseFloat(pay.amount);
            return pay;
          }
        } else if (pay.name !== payment.name && payment.name.toLowerCase() !== "card" && payment.isBankTransfer !== "Y") {
          paid = paid + parseFloat(pay.amount);
          return pay;
        } else if (
          payment.name.toLowerCase() === "card" &&
          (payment.authorization ? pay.authorization !== payment.authorization : true)
        ) {
          paid = paid + parseFloat(pay.amount);
          return pay;
        } else if (
          payment.isBankTransfer === "Y" &&
          (payment.transactionId ? pay.transactionId !== payment.transactionId : pay.name !== payment.name)
        ) {
          paid = paid + parseFloat(pay.amount);
          return pay;
        }
      })
    )
      .then((results) => {
        cart.payments = results.filter((result) => result !== undefined);
        cart.paid = paid + (cart?.advancePayment || 0);
        setAmount(parseFloat((cart.total - cart.paid).toFixed(2)));
        if (payment?.name?.toLowerCase() === "cash") {
          cart.tenderedAmount = cart.tenderedAmount - payment.amount;
        }
        setCart(cart);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const finalizePaymentFlow = async () => {
    if (useRestaurantStore.getState().dineIn === "Y") {
      const updatedTableData = await db.tableData.toArray();
      setTableCards(updatedTableData);
      setMainTableData(updatedTableData);
      setOcupiedTablesData(
        updatedTableData.filter((table) => table.statusType === "OCU" || table.statusType === "ONG")
      );
      setReservedTablesData(updatedTableData.filter((table) => table.statusType === "RES"));
    }

    if (isSplitBill) {
      const updatedSplits = splitCarts.filter((split) => split.splitNo !== removeSplit.splitNo);
      if (updatedSplits.length > 0) {
        const regeneratedSplits = updatedSplits.map((split) => ({
          ...split,
          payments: [],
          isSplit: "Y",
          sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
          referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
          giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
          couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
        }));
        setSplitCarts(regeneratedSplits);
        setCurrentSplitIndex(0);
        setCart(regeneratedSplits[0]);
        setSplitBillScreen(true);
      } else {
        setIsSplitBill(false);
        setSplitCarts([]);
        setCurrentSplitIndex(0);
      }
      useRestaurantStore.getState().setTableName(recordState);
      return;
    }
  };

  const handleOrderCompletion = async () => {
    await new Promise((res) => setTimeout(res, 200));
    const updatedCart = useCartStore.getState().cart;
    if (!updatedCart) return;
    const paid = updatedCart.paid || 0;
    const total = parseFloat(updatedCart.total);

    if (updatedCart.layAway === "Y" && !updatedCart.wasLayaway) {
      if (posConfig?.requirePaymentForAdvance === "Y" && (!paid || paid <= 0)) {
        message.warning("Minimum payment required to create advance order");
        return;
      }
      const layawayCart = {
        ...updatedCart,
        advancePayment: paid,
        layAway: "Y",
        isAdvance: "Y",
        preOrder: "Y",
        statusType: "layAway",
      };
      setCart(layawayCart);
      await processOrder("layaway");
      return;
    }

    if (updatedCart.wasLayaway && updatedCart.isAdvance !== "N") {
      const layawayCart = {
        ...updatedCart,
        layAway: "Y",
        isAdvance: "Y",
        statusType: "layAway",
        advancePayment: paid,
      };
      setCart(layawayCart);
      await processOrder("layaway");
      return;
    }

    if (updatedCart.wasLayaway && updatedCart.isAdvance === "N") {
      if (paid < total) {
        message.warning("Please complete the full payment before finishing the advance order");
        return;
      }
      const layawayCart = {
        ...updatedCart,
        layAway: "Y",
        isAdvance: "N",
        statusType: "",
      };
      setCart(layawayCart);
      await processOrder("layaway");
      return;
    }

    if (paid >= total) {
      await finalizePaymentFlow();
    }
  };

  const printReceipt = () => {};

  // ─── Effects ───────────────────────────────────────────────────────────────

  useEffect(() => {
    const fetchColors = async () => {
      const colors = {};
      for (const order of orderHistoryDetails) {
        if (order?.sOrderID) {
          colors[order.sOrderID] = await findMatchingColor(order);
        }
      }
      setOrderColors(colors);
    };
    fetchColors();
  }, [orderHistoryDetails]);

  useEffect(() => {
    db.orders
      .where("isSynced")
      .equals(1)
      .toArray()
      .then((response) => {
        // tableOrderData state kept local; not needed by child components
      });
  }, [orderTypeData]);

  useEffect(() => {
    const handler = (e) => {
      const sOrderID = e?.detail?.sOrderID;
      if (sOrderID) setCompletedSOrderID(sOrderID);
    };
    window.addEventListener("restaurant:orderComplete", handler);
    return () => window.removeEventListener("restaurant:orderComplete", handler);
  }, []);

  useEffect(() => {
    if (!showOrderCompleteFlag) setCompletedSOrderID(null);
  }, [showOrderCompleteFlag]);

  useEffect(() => {
    if (completedSOrderID) {
      db.orders.where("sOrderID").equals(completedSOrderID).first().then((order) => {
        if (order) {
          setOrderedItem([order]);
          return;
        }
        // Fallback if specific order not found yet
        fetchMostRecentOrder();
      });
    } else {
      fetchMostRecentOrder();
    }

    function fetchMostRecentOrder() {
      db.orders.reverse().limit(50).toArray().then((recentOrders) => {
        const parseOrderTime = (str) => {
          if (!str || typeof str !== "string") return new Date(0);
          const cleaned = str.trim();
          let year, month, day, hour = 0, minute = 0, second = 0;
          if (cleaned.match(/^\d{1,2}-\d{1,2}-\d{4}/)) {
            const [datePart, timePart = "00:00:00"] = cleaned.split(/\s+/);
            const [d, m, y] = datePart.split("-").map(Number);
            day = d; month = m; year = y;
            if (timePart) {
              const [h, min, sec] = timePart.split(":").map(Number);
              hour = h || 0; minute = min || 0; second = sec || 0;
            }
          } else if (cleaned.match(/^\d{4}-\d{1,2}-\d{1,2}/)) {
            const [datePart, timePart = "00:00:00"] = cleaned.split(/\s+/);
            const [y, m, d] = datePart.split("-").map(Number);
            year = y; month = m; day = d;
            if (timePart) {
              const [h, min, sec] = timePart.split(":").map(Number);
              hour = h || 0; minute = min || 0; second = sec || 0;
            }
          } else {
            return new Date(0);
          }
          const date = new Date(year, month - 1, day, hour, minute, second);
          return isNaN(date.getTime()) ? new Date(0) : date;
        };

        const sorted = recentOrders
          .map((order) => ({ ...order, _parsedTime: parseOrderTime(order.orderTime) }))
          .sort((a, b) => b._parsedTime - a._parsedTime);

        if (sorted.length > 0) {
          setOrderedItem([sorted[0]]);
        } else {
          setOrderedItem([]);
        }
      });
    }
  }, [showOrderCompleteFlag, cart, db.orders, completedSOrderID]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.shiftKey && (e.key === "+" || e.key === "-")) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  // ─── Render ────────────────────────────────────────────────────────────────

  return (
    <>
      {showOrderCompleteFlag ? (
        <OrderCompleteScreen
          OrderedItem={OrderedItem}
          currenciesList={currenciesList}
          printReceipt={printReceipt}
          splitCarts={splitCarts}
          setShowOrderCompleteFlag={setShowOrderCompleteFlag}
          setPaymentVisible={setPaymentVisible}
          setSelectedSaleTypeIndex={setSelectedSaleTypeIndex}
          getDefaultSaleType={getDefaultSaleType}
          sortedSaleTypes={sortedSaleTypes}
          setSelectedSaleType={setSelectedSaleType}
          setSelectedSaleTypeData={setSelectedSaleTypeData}
          tillData={tillData}
          userData={userData}
          tillValue={tillValue}
          setCart={setCart}
          setSplitBillScreen={setSplitBillScreen}
          setShowSendToKitchen={setShowSendToKitchen}
          setSplitCarts={setSplitCarts}
          setKeyValue={setKeyValue}
          setShowProducts={setShowProducts}
          setTableCards={setTableCards}
          setOcupiedTablesData={setOcupiedTablesData}
          setReservedTablesData={setReservedTablesData}
          setTableList={setTableList}
          setIsCardPaymentFlag={setIsCardPaymentFlag}
          saleType={saleType}
          setNumSplits={setNumSplits}
          setIsSplitBill={setIsSplitBill}
          setCurrentSplitIndex={setCurrentSplitIndex}
        />
      ) : (
        <div style={{ display: "flex" }}>
          <div style={{ width: cart.items.length > 0 ? "69%" : "100%", height: "100vh" }}>
            {paymentVisible ? (
              <PaymentCheckout
                cart={cart}
                setCart={setCart}
                paymentVisible={paymentVisible}
                setPaymentVisible={setPaymentVisible}
                selectedPaymentMethod={selectedPaymentMethod}
                setSelectedPaymentMethod={setSelectedPaymentMethod}
                setIsCardPaymentFlag={setIsCardPaymentFlag}
                amount={amount}
                setAmount={setAmount}
                onChangeAmount={onChangeAmount}
                paymentModalInputRef={paymentModalInputRef}
                setIsInputFocused={setIsInputFocused}
                requestPayment={requestPayment}
                handleCashPayment={handleCashPayment}
                handleAmount={handleAmount}
                setNumb={setNumb}
                setKeyValue={setKeyValue}
                filteredPaymentMethods={filteredPaymentMethods}
                denaminationsKeyboard={denaminationsKeyboard}
                setDenaminationsKeyboard={setDenaminationsKeyboard}
                handleOrderCompletion={handleOrderCompletion}
                processOrder={processOrder}
                setShowOrderCompleteFlag={setShowOrderCompleteFlag}
                userPreferences={userPreferences}
                tillData={tillData}
                posConfig={posConfig}
                selectedPayment={selectedPayment}
                setSelectedPayment={setSelectedPayment}
                markTableBillRequested={markTableBillRequested}
                restaurantButtonLoading={restaurantButtonLoading}
                setRestaurantButtonLoading={setRestaurantButtonLoading}
              />
            ) : (
              <OrderHistoryList
                orderHistoryDetails={orderHistoryDetails}
                setOrderHistoryDetails={setOrderHistoryDetails}
                ordersCopy={ordersCopy}
                orderColors={orderColors}
                currenciesList={currenciesList}
                searchHistoryInput={searchHistoryInput}
                setSearchhistoryInput={setSearchhistoryInput}
                setIsInputFocused={setIsInputFocused}
                searchOrderHistory={searchOrderHistory}
                filtersFlag={filtersFlag}
                setFiltersFlag={setFiltersFlag}
                dateRange={dateRange}
                loading={loading}
                setLoading={setLoading}
                salesHistoryDrawer={salesHistoryDrawer}
                setSalesHistoryDrawer={setSalesHistoryDrawer}
                selectedOrder={selectedOrder}
                setSelectedOrder={setSelectedOrder}
                returnDrawerOpen={returnDrawerOpen}
                setReturnDrawerOpen={setReturnDrawerOpen}
                returnItem={returnItem}
                setReturnItem={setReturnItem}
                returnQty={returnQty}
                setReturnQty={setReturnQty}
                dataSource={dataSource}
                setDataSource={setDataSource}
                setSelectedReturnOrder={setSelectedReturnOrder}
                setCheckedKeys={setCheckedKeys}
                handleSaveReturnCartRecord={handleSaveReturnCartRecord}
                addSelectedReturnProductsToCart={addSelectedReturnProductsToCart}
                getSalesHistoryData={getSalesHistoryData}
                searchReturnHistory={searchReturnHistory}
                setKeyValue={setKeyValue}
                selectedReturnOrder={selectedReturnOrder}
                sortedSaleTypes={sortedSaleTypes}
                setSelectedSaleTypeIndex={setSelectedSaleTypeIndex}
                handleSelectedSaleTypeForProducts={handleSelectedSaleTypeForProducts}
                setSaleType={setSaleType}
                posConfig={posConfig}
                ObFlag={ObFlag}
                CWHardwareController={CWHardwareController}
                isPrintModeXML={isPrintModeXML}
                upsertPOSLog={upsertPOSLog}
                dispatchEvent={dispatchEvent}
                dateRef={dateRef}
              />
            )}
          </div>

          {cart.items.length > 0 ? (
            <OrderDetailsSidebar
              cart={cart}
              userPreferences={userPreferences}
              saleType={saleType}
              selectedTable={selectedTable}
              guestName={guestName}
              selectedProductId={selectedProductId}
              setSelectedProductId={setSelectedProductId}
              setSelectedProductInCart={setSelectedProductInCart}
              currenciesList={currenciesList}
              charges={charges}
              showCharges={showCharges}
              pricePrecision={pricePrecision}
              handleDeletePayment={handleDeletePayment}
              manualDiscountRestaurant={manualDiscountRestaurant}
              selectedPayment={selectedPayment}
              setSelectedPayment={setSelectedPayment}
              paymentVisible={paymentVisible}
              amount={amount}
              tillData={tillData}
              selectedPaymentMethod={selectedPaymentMethod}
              setNumb={setNumb}
              requestPayment={requestPayment}
              handleOrderCompletion={handleOrderCompletion}
              setTableCards={setTableCards}
              setMainTableData={setMainTableData}
              setOcupiedTablesData={setOcupiedTablesData}
              setReservedTablesData={setReservedTablesData}
              markTableBillRequested={markTableBillRequested}
              isSplitBill={isSplitBill}
              splitCarts={splitCarts}
              removeSplit={removeSplit}
              setSplitCarts={setSplitCarts}
              setCurrentSplitIndex={setCurrentSplitIndex}
              setCart={setCart}
              setSplitBillScreen={setSplitBillScreen}
              setIsSplitBill={setIsSplitBill}
              setKeyValue={setKeyValue}
              recordState={recordState}
              setShowOrderCompleteFlag={setShowOrderCompleteFlag}
              processOrder={processOrder}
              setPaymentVisible={setPaymentVisible}
              restaurantButtonLoading={restaurantButtonLoading}
              setRestaurantButtonLoading={setRestaurantButtonLoading}
            />
          ) : null}
        </div>
      )}
    </>
  );
};

export default React.memo(OrderListComponent);
